import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import findIdByPath from '../utils/findIdByPath';
import { textGray } from '../utils/colors';

const StyledNoMatch = styled.div`
  position: fixed;
  color: ${textGray};
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: ${props => props.theme.primary};
  z-index: 15;
  padding: 3rem;
  text-align: center;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

export default class NoMatch extends Component {
  componentDidMount() {
    const { history, loggedIn } = this.props;

    if (loggedIn) {
      if (history.location.pathname.includes('registrer')) {
        history.push(`/bok/${findIdByPath()}`);
      }
    }
  }

  render() {
    return (
      <StyledNoMatch inverted={true}>
        <h1>404 - Fant ikke siden du lette etter. </h1>
      </StyledNoMatch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoMatch.js